import { DateTime } from 'luxon';
import { processDocument } from '@/features/documents/utils';

export const formatAppraisal = (appraisalModel) => {
  const attributes = {};
  const relationships = {};
  if (appraisalModel.title) {
    attributes.title = appraisalModel.title;
  } else {
    attributes.title = `Tasacion - ${Date.now()}`;
  }
  if (appraisalModel.fechaTasacion) {
    attributes.fecha_tasacion_appraisal = DateTime.fromISO(appraisalModel.fechaTasacion).toISODate();
  }
  if (appraisalModel.importeTasacion) {
    attributes.importe_tasacion = appraisalModel.importeTasacion;
  }
  if ('m2c' in appraisalModel) {
    attributes.m2c = appraisalModel.m2c;
  }
  if (appraisalModel.validezTasacion) {
    attributes.validez_tasacion_appraisal = DateTime.fromISO(appraisalModel.validezTasacion).toISODate();
  }
  if ('valorSeguro' in appraisalModel) {
    attributes.valor_seguro_appraisal = appraisalModel.valorSeguro;
  }
  if (appraisalModel.appraiser) {
    relationships.appraiser = {
      data: {
        id: appraisalModel.appraiser,
        type: 'node--appraiser',
      },
    };
  }
  const id = appraisalModel.id && appraisalModel.id !== 'dummy' ? appraisalModel.id : undefined;
  return {
    id,
    type: appraisalModel.type,
    attributes,
    relationships,
  };
};

export const formatBurden = (burdenModel) => {
  const attributes = {};
  const relationships = {};
  if (burdenModel.comentario) {
    attributes.title = burdenModel.comentario;
  }
  if (burdenModel.importe) {
    attributes.importe_carga = burdenModel.importe;
  }
  if (burdenModel.importePendiente) {
    attributes.importe_pendiente = burdenModel.importePendiente;
  }
  if (burdenModel.rango) {
    relationships.rango = {
      data: {
        id: burdenModel.rango,
        type: 'taxonomy_term--rango_cargas',
      },
    };
    attributes.importe_pendiente = burdenModel.importePendiente;
  }
  const id = burdenModel.id && burdenModel.id !== 'dummy' ? burdenModel.id : undefined;
  return {
    id,
    type: burdenModel.type,
    attributes,
    relationships,
  };
};

export const formatOwner = (ownerModel) => {
  const attributes = {};
  if (ownerModel.dni) {
    attributes.dni = ownerModel.dni;
  }
  if (ownerModel.nombre) {
    attributes.nombre = ownerModel.nombre;
  }
  if (ownerModel.apellidos) {
    attributes.apellidos_owner = ownerModel.apellidos;
  }
  if (ownerModel.title) {
    attributes.title = ownerModel.title;
  } else {
    attributes.title = `${ownerModel.apellidos} - ${ownerModel.nombre}`;
  }
  const id = ownerModel.id && ownerModel.id !== 'dummy' ? ownerModel.id : undefined;
  return {
    id,
    type: 'node--owner',
    attributes,
  };
};

export const formatMarketResearch = (marketResearchModel) => {
  const attributes = {};
  const relationships = {};
  if (marketResearchModel.title) {
    attributes.title = marketResearchModel.title;
  } else if (attributes.url) {
    attributes.title = marketResearchModel.url;
  } else {
    attributes.title = new Date();
  }
  if (marketResearchModel.fecha) {
    const dateTime = DateTime.fromISO(marketResearchModel.fecha);
    attributes.fecha_consulta =
      `${dateTime.toISODate()}T${dateTime.toISOTime({ suppressMilliseconds: true, includeOffset: false })}`;
  }
  if (marketResearchModel.nombre) {
    attributes.nombre_consulta = marketResearchModel.nombre;
  }
  if (marketResearchModel.url) {
    attributes.url_consulta = marketResearchModel.url;
  }
  if (marketResearchModel.precioM2) {
    attributes.precio_m2 = marketResearchModel.precioM2;
  }
  if (marketResearchModel.source) {
    relationships.market_research_source = {
      data: {
        id: marketResearchModel.source,
        type: 'taxonomy_term--market_research_source',
      },
    };
  }
  if (marketResearchModel.pdfs && marketResearchModel.pdfs.length > 0) {
    const data = marketResearchModel.pdfs.map(pdf => Object.assign({}, { id: pdf.id, type: pdf.type ? pdf.type : 'file--file' }));
    relationships.pdfs = { data };
  }
  const id = marketResearchModel.id && marketResearchModel.id !== 'dummy' ? marketResearchModel.id : undefined;
  return {
    id,
    type: marketResearchModel.type,
    attributes,
    relationships,
  };
};

export const formatPropertyMarket = (propertyMarketModel) => {
  const attributes = {};
  if ('title' in propertyMarketModel) {
    attributes.title = propertyMarketModel.title;
  } else {
    attributes.title = `PropertyMarket - ${Date.now()}`;
  }
  if ('ltv' in propertyMarketModel) {
    attributes.ltv_property = propertyMarketModel.ltv;
  }
  if ('m2Medio' in propertyMarketModel) {
    attributes.m2_medio = propertyMarketModel.m2Medio;
  }
  if ('mapUrl' in propertyMarketModel) {
    attributes.map_url_market = propertyMarketModel.mapUrl;
  }
  if ('nexumPropertyMarketPrice' in propertyMarketModel) {
    attributes.nexum_property_price = propertyMarketModel.nexumPropertyMarketPrice;
  }
  if ('propertyMarketPrice' in propertyMarketModel) {
    attributes.property_market_price = propertyMarketModel.propertyMarketPrice;
  }
  const relationships = {};
  if (propertyMarketModel.marketResearchs && propertyMarketModel.marketResearchs.length > 0) {
    const data = propertyMarketModel.marketResearchs.map(mr => Object.assign({}, { id: mr.id, type: 'node--market_research' }));
    relationships.marker_researchs = { data };
  }
  const id = propertyMarketModel.id && propertyMarketModel.id !== 'dummy' ? propertyMarketModel.id : undefined;
  return {
    id,
    type: propertyMarketModel.type,
    attributes,
    relationships,
  };
};

export const formatPledge = (pledgeModel) => {
  const attributes = {};
  const relationships = {};
  if ('cp' in pledgeModel) {
    // attributes.codigo_pos = pledgeModel.cp;
    attributes.codpos = pledgeModel.cp;
  }
  if ('direccion' in pledgeModel) {
    attributes.direccion = pledgeModel.direccion;
  }
  if ('poblacion' in pledgeModel) {
    attributes.poblacion = pledgeModel.poblacion;
  }
  if ('catastro' in pledgeModel) {
    attributes.ref_catastral = pledgeModel.catastro;
  }
  if ('analisis' in pledgeModel) {
    attributes.comentarios_analisis = pledgeModel.analisis;
  }
  if ('finca' in pledgeModel) {
    attributes.num_finca = pledgeModel.finca;
  }
  if ('registro' in pledgeModel) {
    attributes.num_registro_propiedad = pledgeModel.registro;
  }
  if ('tomo' in pledgeModel) {
    attributes.tomo = pledgeModel.tomo;
  }
  if ('libro' in pledgeModel) {
    attributes.libro = pledgeModel.libro;
  }
  if ('folio' in pledgeModel) {
    attributes.folio = pledgeModel.folio;
  }
  if ('m2c' in pledgeModel) {
    attributes.m2_calculados = pledgeModel.m2c;
  }
  if ('m2u' in pledgeModel) {
    attributes.m2_utiles = pledgeModel.m2u;
  }
  if ('tipoVivienda' in pledgeModel) {
    attributes.vivienda_habitual = pledgeModel.tipoVivienda;
  }
  if (pledgeModel.burdens && pledgeModel.burdens.length > 0) {
    const data = pledgeModel.burdens.map(b => Object.assign({}, { id: b.id, type: 'node--burden' }));
    relationships.burdens = { data };
  }
  if (pledgeModel.owners && pledgeModel.owners.length > 0) {
    const data = pledgeModel.owners.map(o => Object.assign({}, { id: o.id, type: 'node--owner' }));
    relationships.owners = { data };
  }
  if (pledgeModel.appraisals && pledgeModel.appraisals.length > 0) {
    const data = pledgeModel.appraisals.map(a => Object.assign({}, { id: a.id, type: 'node--appraisal' }));
    relationships.appraisals = { data };
  }
  if (pledgeModel.propertyMarket) {
    const data = { id: pledgeModel.propertyMarket.id, type: 'node--property_market' };
    relationships.property_market = { data };
  }
  if (pledgeModel.title) {
    attributes.title = pledgeModel.title;
  } else {
    attributes.title = `${pledgeModel.direccion}`;
  }
  const id = pledgeModel.id && pledgeModel.id !== 'dummy' ? pledgeModel.id : undefined;
  return {
    id,
    type: 'node--pledge',
    attributes,
    relationships,
  };
};

export const processOwner = (owner) => {
  const ownerModel = {
    id: owner.id,
    type: owner.type,
  };
  const { attributes } = owner;
  if (attributes.title) {
    ownerModel.title = attributes.title;
  }
  if (attributes.dni) {
    ownerModel.dni = attributes.dni;
  } else {
    ownerModel.dni = '';
  }
  if (attributes.nombre) {
    ownerModel.nombre = attributes.nombre;
  } else {
    ownerModel.nombre = '';
  }
  if (attributes.apellidos_owner) {
    ownerModel.apellidos = attributes.apellidos_owner;
  } else {
    ownerModel.apellidos = '';
  }
  return ownerModel;
};

export const processBurden = (burden) => {
  const burdenModel = {
    id: burden.id,
    type: burden.type,
  };
  const { attributes, relationships } = burden;
  if (attributes.title) {
    burdenModel.comentario = attributes.title;
  }
  if (attributes.importe_carga) {
    burdenModel.importe = attributes.importe_carga;
  } else {
    burdenModel.importe = 0;
  }
  if (attributes.importe_pendiente) {
    burdenModel.importePendiente = attributes.importe_pendiente;
  } else {
    burdenModel.importePendiente = 0;
  }
  if (relationships.rango &&
    relationships.rango.data) {
    burdenModel.rango = relationships.rango.data.id;
  }
  return burdenModel;
};

export const processAppraisal = (appraisal) => {
  const appraisalModel = {
    id: appraisal.id,
    type: appraisal.type,
  };
  const { attributes, relationships } = appraisal;
  if (attributes.title) {
    appraisalModel.title = attributes.title;
  }
  if (attributes.fecha_tasacion_appraisal) {
    appraisalModel.fechaTasacion = DateTime.fromSQL(attributes.fecha_tasacion_appraisal).toISODate();
  }
  if (attributes.importe_tasacion) {
    appraisalModel.importeTasacion = attributes.importe_tasacion;
  }
  if ('m2c' in attributes) {
    appraisalModel.m2c = attributes.m2c;
  }
  if (attributes.validez_tasacion_appraisal) {
    appraisalModel.validezTasacion = DateTime.fromSQL(attributes.validez_tasacion_appraisal).toISODate();
  }
  if (attributes.valor_seguro_appraisal) {
    appraisalModel.valorSeguro = attributes.valor_seguro_appraisal;
  }
  if (relationships.appraiser &&
    relationships.appraiser.data) {
    appraisalModel.appraiserId = relationships.appraiser.data.id;
  }

  return appraisalModel;
};

export const processMarketResearchIncluded = (marketResearch, included) => {
  const relationships = marketResearch.relationships;
  const pdfs = [];
  if (included && included.length > 0) {
    included.forEach((rel) => {
      if (rel.type === 'node--document') {
        if (relationships &&
          relationships.pdfs &&
          relationships.pdfs.data &&
          relationships.pdfs.data.length > 0) {
          relationships.pdfs.data.forEach((pdf) => {
            if (pdf.id === rel.id) {
              pdfs.push(processDocument(rel));
            }
          });
        }
      }
    });
  }
  return { pdfs };
};

export const processMarketResearch = (marketResearch, included) => {
  const propertyMarketModel = {
    id: marketResearch.id,
    type: marketResearch.type,
  };
  const { attributes, relationships } = marketResearch;
  if ('title' in attributes) {
    propertyMarketModel.title = attributes.title;
  }
  if ('fecha_consulta' in attributes) {
    propertyMarketModel.fecha = DateTime.fromISO(attributes.fecha_consulta).toISODate();
  }
  if (attributes.nombre_consulta) {
    propertyMarketModel.nombre = attributes.nombre_consulta;
  }
  if (attributes.url_consulta) {
    propertyMarketModel.url = attributes.url_consulta;
  }
  if (attributes.precio_m2) {
    propertyMarketModel.precioM2 = attributes.precio_m2;
  } else {
    propertyMarketModel.precioM2 = 0;
  }
  if (relationships.market_research_source &&
    relationships.market_research_source.data) {
    propertyMarketModel.source = relationships.market_research_source.data.id;
  }
  if (included &&
    included.pdfs &&
    relationships.pdfs &&
    relationships.pdfs.data) {
    propertyMarketModel.pdfs = included.pdfs;
  }
  return propertyMarketModel;
};

export const processPropertyMarketIncluded = (propertyMarket, included) => {
  const relationships = propertyMarket.relationships;
  const marketResearchs = [];
  if (included && included.length > 0) {
    included.forEach((rel) => {
      if (rel.type === 'node--market_research') {
        if (relationships &&
          relationships.marker_researchs &&
          relationships.marker_researchs.data &&
          relationships.marker_researchs.data.length > 0) {
          relationships.marker_researchs.data.forEach((marketResearch) => {
            if (marketResearch.id === rel.id) {
              marketResearchs.push(processMarketResearch(rel));
            }
          });
        }
      }
    });
  }
  return { marketResearchs };
};

export const processPropertyMarket = (propertyMarket, included) => {
  const propertyMarketModel = {
    id: propertyMarket.id,
    type: propertyMarket.type,
  };
  const { attributes, relationships } = propertyMarket;
  if ('title' in attributes) {
    propertyMarketModel.title = attributes.title;
  }
  if (attributes.ltv_property) {
    propertyMarketModel.ltv = attributes.ltv_property;
  }
  if (attributes.m2_medio) {
    propertyMarketModel.m2Medio = attributes.m2_medio;
  }
  if (attributes.map_url_market) {
    propertyMarketModel.mapUrl = attributes.map_url_market;
  }
  if (attributes.nexumPropertyMarketPrice) {
    propertyMarketModel.nexumPropertyMarketPrice = attributes.nexum_property_price;
  }
  if (attributes.nexum_peroperty_market_price) {
    propertyMarketModel.propertyMarketPrice = attributes.property_market_price;
  }
  if (included &&
    included.marketResearchs &&
    relationships.marker_researchs &&
    relationships.marker_researchs.data &&
    relationships.marker_researchs.data.length > 0) {
    propertyMarketModel.marketResearchs = included.marketResearchs;
  }
  return propertyMarketModel;
};

export const processPledgeIncluded = (pledge, included) => {
  const relationships = pledge.relationships;
  const owners = [];
  const burdens = [];
  const appraisals = [];
  let propertyMarket = {};
  if (included && included.length > 0) {
    included.forEach((rel) => {
      if (rel.type === 'node--burden') {
        if (relationships &&
          relationships.burdens &&
          relationships.burdens.data &&
          relationships.burdens.data.length > 0) {
          relationships.burdens.data.forEach((b) => {
            if (b.id === rel.id) {
              burdens.push(processBurden(rel));
            }
          });
        }
      }
      if (rel.type === 'node--owner') {
        if (relationships &&
          relationships.owners &&
          relationships.owners.data &&
          relationships.owners.data.length > 0) {
          relationships.owners.data.forEach((o) => {
            if (o.id === rel.id) {
              owners.push(processOwner(rel));
            }
          });
        }
      }
      if (rel.type === 'node--appraisal') {
        if (relationships &&
          relationships.appraisals &&
          relationships.appraisals.data &&
          relationships.appraisals.data.length > 0) {
          relationships.appraisals.data.forEach((o) => {
            if (o.id === rel.id) {
              appraisals.push(processAppraisal(rel));
            }
          });
        }
      }
      if (rel.type === 'node--property_market') {
        if (relationships &&
          relationships.property_market &&
          relationships.property_market.data &&
          relationships.property_market.data.id === rel.id) {
          propertyMarket = processPropertyMarket(rel);
        }
      }
    });
    return { owners, burdens, appraisals, propertyMarket };
  }
  return null;
};

export const processPledge = (garantia, included) => {
  const garantiaModel = {
    id: garantia.id,
    type: garantia.type,
  };
  const { attributes, relationships } = garantia;
  if (attributes.title) {
    garantiaModel.title = attributes.title;
  }
  if (attributes.direccion) {
    garantiaModel.direccion = attributes.direccion;
  }
  if (attributes.codpos) {
    garantiaModel.cp = attributes.codpos;
  }/*
  if ('codigo_pos' in attributes) {
    garantiaModel.cp = attributes.codigo_pos;
  } */
  if (attributes.poblacion) {
    garantiaModel.poblacion = attributes.poblacion;
  }
  if (attributes.comentarios_analisis) {
    garantiaModel.analisis = attributes.comentarios_analisis;
  }
  if (attributes.ref_catastral) {
    garantiaModel.catastro = attributes.ref_catastral;
  }
  if (attributes.num_finca) {
    garantiaModel.finca = attributes.num_finca;
  }
  if (attributes.num_registro_propiedad) {
    garantiaModel.registro = attributes.num_registro_propiedad;
  }
  if (attributes.tomo) {
    garantiaModel.tomo = attributes.tomo;
  }
  if (attributes.libro) {
    garantiaModel.libro = attributes.libro;
  }
  if (attributes.folio) {
    garantiaModel.folio = attributes.folio;
  }
  if (attributes.m2_calculados) {
    garantiaModel.m2c = attributes.m2_calculados;
  }
  if (attributes.m2_utiles) {
    garantiaModel.m2u = attributes.m2_utiles;
  }
  if (attributes.vivienda_habitual) {
    garantiaModel.tipoVivienda = attributes.vivienda_habitual ? 1 : 0;
  }
  if (included && included.burdens &&
    relationships.burdens &&
    relationships.burdens.data &&
    relationships.burdens.data.length > 0) {
    garantiaModel.burdens = included.burdens;
  }
  if (included && included.owners &&
    relationships.owners &&
    relationships.owners.data &&
    relationships.owners.data.length > 0) {
    garantiaModel.owners = included.owners;
  }
  if (included && included.appraisals &&
    relationships.appraisals &&
    relationships.appraisals.data &&
    relationships.appraisals.data.length > 0) {
    garantiaModel.appraisals = included.appraisals;
  }
  if (included && included.propertyMarket &&
    relationships.property_market &&
    relationships.property_market.data) {
    garantiaModel.propertyMarket = included.propertyMarket;
  }
  return garantiaModel;
};

export const processOwnerResponse = (res) => {
  if (res.data.meta) {
    return res.data.data.map(owner => processOwner(owner));
  }
  return processOwner(res.data.data);
};

export const processBurdenResponse = (res) => {
  if (res.data.meta) {
    return res.data.data.map(burden => processBurden(burden));
  }
  return processBurden(res.data.data);
};

export const processAppraisalResponse = (res) => {
  if (res.data.meta) {
    return res.data.data.map(appraisal => processAppraisal(appraisal));
  }
  return processAppraisal(res.data.data);
};

export const processMarketResearchResponse = (res) => {
  if (res.data.meta) {
    return res.data.data.map(marketResearch =>
      processMarketResearch(marketResearch, processMarketResearchIncluded(marketResearch, res.data.included)));
  }
  return processMarketResearch(res.data.data, processMarketResearchIncluded(res.data.data, res.data.included));
};

export const processPropertyMarketResponse = (res) => {
  if (res.data.meta) {
    return res.data.data.map(propertyMarket =>
      processPropertyMarket(propertyMarket, processPropertyMarketIncluded(propertyMarket, res.data.included)));
  }
  return processPropertyMarket(res.data.data, processPropertyMarketIncluded(res.data.data, res.data.included));
};

export const processPledgeResponse = (res) => {
  if (res.data.meta) {
    return res.data.data.map(pledge => processPledge(pledge, processPledgeIncluded(pledge, res.data.included)));
  }
  return processPledge(res.data.data, processPledgeIncluded(res.data.data, res.data.included));
};



// WEBPACK FOOTER //
// ./src/features/tab-garantia/utils.js